import { render, staticRenderFns } from "./standardsectionadd.vue?vue&type=template&id=e54d71cc&scoped=true"
import script from "./standardsectionadd.vue?vue&type=script&lang=js"
export * from "./standardsectionadd.vue?vue&type=script&lang=js"
import style0 from "./standardsectionadd.vue?vue&type=style&index=0&id=e54d71cc&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54d71cc",
  null
  
)

export default component.exports